import React, { FC } from "react";

export interface SectionSubHeroProps {
    title: string;
    pillTitle?: string;
    description?: string;
    bgClass?: string;
    className?: string;
}

const SectionSubHero: FC<SectionSubHeroProps> = ({
    title,
    pillTitle,
    description,
    bgClass = "dashboard-sub-bg",
    className = "",
}) => {
    return (
        <div
            className={`relative w-full overflow-hidden ${bgClass} ${className}`}
            data-nc-id="SectionSubHero"
        >
            {/* Background decorative elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-20 -right-20 w-40 h-40 bg-amber-500/5 rounded-full blur-2xl"></div>
                <div className="absolute -bottom-10 -left-20 w-48 h-48 bg-amber-500/3 rounded-full blur-2xl"></div>
            </div>

            {/* Main content container */}
            <div className="relative z-10 mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 md:py-20 text-center justify-center">
                <div className="max-w-4xl mx-auto">
                    <div className="px-4 sm:px-6 lg:px-8 py-16 sm:py-24 text-center flex flex-col items-center">
                        <div className="max-w-7xl mx-auto">
                            <div className="mb-4">
                                {pillTitle && <span className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/10 rounded-full border border-amber-500/20">
                                    <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
                                    <span className="text-xs sm:text-sm font-medium text-amber-600">
                                        {pillTitle}
                                    </span>
                                </span>}
                            </div>
                            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-gray-100 mb-6 leading-tight tracking-tight text-balance">
                                {title}
                            </h1>
                            <p className="text-base sm:text-lg text-gray-300 max-w-2xl leading-relaxed text-center">
                                {description}
                            </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SectionSubHero;
